import { render, staticRenderFns } from "./PromotionManagement.vue?vue&type=template&id=471a5166&scoped=true"
import script from "./PromotionManagement.vue?vue&type=script&lang=js"
export * from "./PromotionManagement.vue?vue&type=script&lang=js"
import style0 from "./PromotionManagement.vue?vue&type=style&index=0&id=471a5166&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471a5166",
  null
  
)

export default component.exports